<template>
  <div v-if="$store.getters.getNotifications" class="notification-container">
    <div class="notification-close" @click="cancelNotification">
      <icon type="xmark"/>
    </div>
    <div class="notification-text">
      <p>{{ $store.getters.getNotifications }}</p>
    </div>
  </div>
</template>

<script>
import Icon from "./Icon";
import {mapState} from 'vuex';

export default {
  name: 'Notification',
  components: {
    Icon,
  },
  props: {
    duration: {type: Number, default: 12000}
  },
  data() {
    return {
      notificationTimeout: null,
    }
  },
  computed: mapState({
    notification: state => state.notifications.notification,
    permanentNotification: state => state.notifications.permanentNotification,
  }),
  watch: {
    permanentNotification(newval) {
      if (newval) {
        this.unsetNotificationTimeout();
      } else {
        this.setNotificationTimeout();
      }
    },
    notification(newval) {
      if (newval.length > 0) {
        this.setNotificationTimeout();
      }
    },
  },

  mounted() {
    this.setNotificationTimeout();
  },
  methods: {
    cancelNotification() {
      this.$store.dispatch('cancelNotification', {'text': ''});
    },
    unsetNotificationTimeout() {
      if(this.notificationTimeout) {
        clearTimeout(this.notificationTimeout);
        this.notificationTimeout = null;
      }
    },
    setNotificationTimeout () {
      if (this.permanentNotification) {
        this.unsetNotificationTimeout();
        return;
      }
      this.notificationTimeout = setTimeout(() => {
        this.cancelNotification();
      }, this.duration);
    }
  }
}
</script>
<style lang="scss">
.notification-container {
  position: fixed;
  bottom: 15px;
  right: 15px;
  width: 300px;
  background-color: #000;
  padding: 25px;
  z-index: 10003;
}

.notification-close {
  color: #fff;
  position: absolute;
  top: 15px;
  right: 15px;
  cursor: pointer;
  padding: 5px;
}

@keyframes fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
</style>
